export function NextIcon(props) {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.46967 2.21967C4.17678 2.51256 4.17678 2.98744 4.46967 3.28033L7.18934 6L4.46967 
                8.71967C4.17678 9.01256 4.17678 9.48744 4.46967 9.78033C4.76256 10.0732 5.23744 10.0732 
                5.53033 9.78033L8.78033 6.53033C9.07322 6.23744 9.07322 5.76256 8.78033 5.46967L5.53033 
                2.21967C5.23744 1.92678 4.76256 1.92678 4.46967 2.21967Z"
            />
        </svg>
    )
}